import type { PenilaiPerencanaanMenu } from 'types/kinerja-tim-penilai-penilik'

export const PERENCANAAN_STEPS_TIM_KINERJA = [
  {
    title: 'Periksa Perencanaan',
    subtitle: 'Oleh Tim Kinerja dan Pejabat Penilai Kinerja',
    icon: 'img-clip-board-summary',
  },
  {
    title: 'Rekomendasi Persetujuan Perencanaan ke Pejabat Penilai Kinerja',
    subtitle: 'Oleh Tim Kinerja',
    icon: 'img-publish-data',
  },
  {
    title: 'Setujui Perencanaan',
    subtitle: 'Oleh Pejabat Penilai Kinerja',
    icon: 'img-document-penci-fill',
  },
  {
    title: 'Tahap Pelaksanaan',
    subtitle: 'Oleh Penilik',
    icon: 'img-thumbs-up',
  },
]

export const PERENCANAAN_STEPS_PEJABAT_PENILAI_KINERJA = [
  {
    title: 'Periksa Perencanaan',
    subtitle: 'Oleh Tim Kinerja dan Pejabat Penilai Kinerja',
    icon: 'img-clip-board-summary',
  },
  {
    title: 'Setujui Perencanaan',
    subtitle: 'Oleh Pejabat Penilai Kinerja',
    icon: 'img-document-penci-fill',
  },
  {
    title: 'Tahap Pelaksanaan',
    subtitle: 'Oleh Penilik',
    icon: 'img-thumbs-up',
  },
]

export const PERENCANAAN_TIM_KINERJA_MENUS: PenilaiPerencanaanMenu[] = [
  {
    key: 'not-submitted',
    title: 'Belum diajukan Penilik',
    subtitle: 'Kabari Penilik untuk segera mengajukan.',
    ctaText: 'Cek Daftar Penilik',
    textColor: 'default',
    subtitleColor: 'subdued',
    ctaColor: 'white',
    path: '/perencanaan/daftar-penilik/belum-diajukan',
  },
  {
    key: 'submitted',
    title: 'Sudah diajukan Penilik',
    subtitle: 'Periksa Perencanaan yang sudah diajukan Penilik.',
    textColor: 'default',
    subtitleColor: 'subdued',
    ctaText: 'Periksa',
    ctaColor: 'black',
    path: '/perencanaan/daftar-penilik',
  },
]

export const PERENCANAAN_PEJABAT_PENILAI_KINERJA_MENUS: PenilaiPerencanaanMenu[] =
  [
    {
      key: 'not-submitted',
      title: 'Belum diajukan Penilik',
      subtitle: 'Kabari Penilik untuk segera mengajukan.',
      subtitleColor: 'subdued',
      textColor: 'default',
      ctaText: 'Cek daftar Penilik',
      ctaColor: 'white',
      path: '/perencanaan/daftar-penilik/belum-diajukan',
    },
    {
      key: 'single-approval',
      title: 'Periksa satu per satu',
      subtitle: 'Periksa tiap perencanaan untuk setujui atau arahkan revisi.',
      textColor: 'default',
      subtitleColor: 'subdued',
      ctaText: 'Periksa satu per satu',
      ctaColor: 'black',
      path: '/perencanaan/daftar-penilik',
    },
    {
      key: 'bulk-approval',
      title: 'Setujui sekaligus',
      subtitle:
        'Perencanaan yang sudah diperiksa Tim Kinerja dapat Anda setujui sekaligus.',
      textColor: 'default',
      subtitleColor: 'subdued',
      ctaText: 'Setujui Sekaligus',
      ctaColor: 'black',
      path: '/perencanaan/daftar-penilik/setujui-sekaligus',
    },
  ]

export const PERENCANAAN_PENGEMBANGAN_KOMPETENSI_HINTS: Array<string> = [
  'Berdasarkan diskusi dengan Penilik tentang fokus dan kemampuan selama 6 bulan ke depan',
  'Berdasarkan hasil Refleksi Kompetensi Penilik',
]
